import { useMemo } from 'react';
import { TaskWithState, TaskState, NextTask } from '../types';
import { formatShortCountdown } from '../utils/timeSource';

export function useNextUp(
  tasks: TaskWithState[],
  currentTime: Date,
  previewWindowMinutes: number
): NextTask {
  return useMemo(() => {
    const now = currentTime.getTime();
    const previewWindowMs = previewWindowMinutes * 60 * 1000;

    // First, check for active tasks
    const activeTask = tasks.find(task => task.state === TaskState.ACTIVE);
    
    if (activeTask) {
      const timeLeft = activeTask.endTime.getTime() - now;
      return {
        task: activeTask,
        countdownText: `${formatShortCountdown(timeLeft)} LEFT`,
        timeLeft
      };
    }

    // If no active task, find the next upcoming task within the preview window
    const upcomingTasks = tasks
      .filter(task => task.state === TaskState.UPCOMING)
      .sort((a, b) => a.startTime.getTime() - b.startTime.getTime());

    for (const task of upcomingTasks) {
      const timeUntilStart = task.startTime.getTime() - now;
      
      if (timeUntilStart <= previewWindowMs) {
        return {
          task,
          countdownText: `in ${formatShortCountdown(timeUntilStart)}`,
          timeLeft: timeUntilStart
        };
      }
    }

    // No task in preview window
    return {
      task: null,
      countdownText: '',
      timeLeft: 0
    };
  }, [tasks, currentTime, previewWindowMinutes]);
}

